// extracted by mini-css-extract-plugin
export default {"layout":"cf7407f5fb aa05ffd545 _3c6fc6a4bb","h_slide":"_1e34ba73b3","category":"dcd981492a _349e841d10 _79b54f1839"};